import { render, staticRenderFns } from "./app-button.vue?vue&type=template&id=a11ca112"
import script from "./app-button.vue?vue&type=script&lang=ts"
export * from "./app-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports